import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { AlertService, VerifystudentService } from '../_services';
import { Globals } from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.css']
})

export class FeedbackComponent implements OnInit {
    @ViewChild('mandatorySwal') private mandatorySwal: SwalComponent;
    @ViewChild('signSwal') private signSwal: SwalComponent;
    typeFormControl = new FormControl('', [
        Validators.required
    ]);    
    type1FormControl = new FormControl('', [
        Validators.required
    ]);
    type2FormControl = new FormControl('', [
        Validators.required
    ]);
    type3FormControl = new FormControl('', [
        Validators.required
    ]);  
    type4FormControl = new FormControl('', [
        Validators.required
    ]); 
    type5FormControl = new FormControl('', [
        Validators.required
    ]);             
    matcher = new MyErrorStateMatcher();

    public alertOption: SweetAlertOptions = {};

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userData = {};
    feedbacksettings = {};
    feedback_id: number;   
    feedback_id_student: number;   
    feedbackdone: string;           
    enroll_no: string;          
    batch_name: string;           
    center_id : string;          
    tc_name: string;
    student_name: string;
    settings = {};
    minDate: Date;
    maxDate: Date;
    list = {};
    options = []; 
    type4_1 = [
        {id: 1, name:'Strongly Agree'},
        {id: 2, name:'Agree'},
        {id: 3, name:'Disagree'},
        {id: 4, name:'Strongly Disagree'}];
    type4_2 = [
        {id: 1, name:'Excellent'},
        {id: 2, name:'Good'},
        {id: 3, name:'Average'},
        {id: 4, name:'Poor'}];
    type2 = [
        {id: 1, name:'Yes'},
        {id: 2, name:'No'}];   
    t = false;
    t1 = false;
    t2 = false;
    t3 = false;
    t4 = false;
    t5 = false;
    ans:string = '';
    SubmitObj = [];         
    context; 
    src; 
    imgs;
    feedback_status: number = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private verifystudentService: VerifystudentService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {
        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 5, 0, 1);
        this.maxDate = new Date(currentYear);
    }


    ngOnInit() {
        var param = this.route.snapshot.paramMap.get("step");
        //this.feedback_id = parseInt(this.route.snapshot.paramMap.get("step1"));
        var params = param.split('@@');
        if(params.length != 2)
        {
            console.log('Need to display wrong page message and redirect theory test page.');
        }
        else
        {
            console.log('match feedback id else redirect to theory test page .');
            this.feedback_id = parseInt(params[1]);
            this.feedback_id_student = parseInt(params[0]);
        }

                //if (!this.feedback_id)
            //this.router.navigateByUrl('/login');

        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set); 
        //console.log(sessionStorage.pkshn_feedback_set);
        if(sessionStorage.pkshn_feedback_set != undefined)
        {
            this.feedbacksettings = JSON.parse(sessionStorage.pkshn_feedback_set); 
            this.feedback_status = this.feedbacksettings['feedback_status'];
        }
        if(this.feedback_status == 1)
        {
            var parms = this.globals.getRandUrl('test-start');
            this.router.navigateByUrl('/test-start/' + parms);            
        }
        else
        {
            this.getFeedbackQuestions();            
        }                

    }


    public getFeedbackQuestions() {
        this.verifystudentService.getFeedbackQuestions(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.feedback_id)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.feedback_id = data.feedback_id;             
                    var list = data.list;  
                    //this.list = Array.of(this.list); 
                    for (var i = 0; i < data.list.length; ++i) {
                        this.options[i] = { fbq_type_name: list[i].fbq_type_name, feedback_id: list[i].feedback_id, id_fbq_type: list[i].id_fbq_type, max_rating: list[i].max_rating, question: list[i].question, question_id: list[i].question_id };
                        switch(list[i].id_fbq_type)
                        {
                            case 1: this.t1 = true; break;
                            case 2: this.t2 = true; break;
                            case 3: this.t3 = true; break;
                            case 4: this.t = true; break;
                            case 5: this.t5 = true; break;
                        }
                    } 
                    this.spinner.hide();  
                    this.loading = false;                               
              }
              else if (data.code == 1001) {
                this.loading = false;
                this.isErrorLogin = false;
                //this.router.navigateByUrl('/login'); 18002086633 
              }
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
          );
    }

    public onSubmit() {
        if(this.isErrorLogin == true)
        {
            this.mandatorySwal.show();
            return false;           
        }
        var canvas = document.getElementsByTagName('canvas');
        this.src = canvas[0].toDataURL("image/png");
        var canvasnew = <HTMLCanvasElement>document.getElementById('canvasnew');
        this.imgs = canvasnew.toDataURL("image/png");
        if (this.src == this.imgs) {
            this.signSwal.show();
            return;
        }        
        this.loading = true;
        this.spinner.show();
        var studentsStr = JSON.stringify(this.SubmitObj);        
        this.verifystudentService.setFeedbackQuestions(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.feedback_id, this.feedback_id_student, studentsStr, this.src, 1)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                this.loading = false;
                this.spinner.hide();
                let sett = { 'feedbackid': this.feedback_id, 'feedback_status': 1 };
                sessionStorage.setItem('pkshn_feedback_set', JSON.stringify(sett));                
                var parms = this.globals.getRandUrl('test-start');
                this.router.navigateByUrl('/test-start/' + parms);
              }
              else if (data.code == 1001) {
                this.loading = false;
                this.isErrorLogin = false;
                //this.router.navigateByUrl('/login');
              }
            }
          )  
    } 

    public openSignArea()
    {
        this.submitted = true;
        if(this.typeFormControl.value == '' && this.t4 == true) this.isErrorLogin = true;
        if(this.type1FormControl.value == '' && this.t1 == true) this.isErrorLogin = true;
        if(this.type2FormControl.value == '' && this.t2 == true) this.isErrorLogin = true;
        if(this.type3FormControl.value == '' && this.t3 == true) this.isErrorLogin = true;
        if(this.type5FormControl.value == '' && this.t5 == true) this.isErrorLogin = true;

        if (this.isErrorLogin == true) {
            this.isErrorLogin = false;
            this.mandatorySwal.show();
            return false;
        }
        else
        {
            document.getElementById('sign-area').style.display = 'block'; 
            document.getElementById('sign-button').style.display = 'none';
            document.getElementById('submit-button').style.display = 'block'; 
            document.getElementById("signature").scrollIntoView();                    
        }

    }
    public clear() {
        const canvas = <HTMLCanvasElement>document.getElementById('canvas1');
        this.context = canvas.getContext('2d');
        this.context.clearRect(0, 0, 800, 300);
    }

    method(event,qid,ftypeid) {
        this.ans = event.target.value;
        if(this.ans != '')
        {
            for (var i = 0; i < this.SubmitObj.length; i++) {
                if (this.SubmitObj[i].feedback_ques_id == qid)
                    this.SubmitObj.splice(i, 1);
            }
            this.SubmitObj.push({ feedback_ques_id: qid, feedback_id: this.feedback_id, student_rating: 0, remarks: this.ans, id_fbq_type: ftypeid });
            this.isErrorLogin = false;
        }
        else{
            this.isErrorLogin = true;
        }
   }
    optSelect(event,qid,ftypeid,val) {
        if(event.target.checked == true)
        {
            for (var i = 0; i < this.SubmitObj.length; i++) {
                if (this.SubmitObj[i].feedback_ques_id == qid)
                    this.SubmitObj.splice(i, 1);
            }
            this.SubmitObj.push({ feedback_ques_id: qid, feedback_id: this.feedback_id, student_rating: val, remarks: '', id_fbq_type: ftypeid });
        }
   }
}
